import { PaymentAction } from "./../../actionTypes/payment";
import { PaymentActionTypes } from "../../../../enums/payment";

const {
  PAYMENT_CANCELLED,
  PAYMENT_STARTED,
  PAYMENT_IN_REVIEW,
  PAYMENT_CREATED,
  PAYMENT_SOURCE_UPDATED,
} = PaymentActionTypes;

export function setPaymentCancelled(): PaymentAction {
  return {
    type: PAYMENT_CANCELLED,
  };
}

export function setPaymentStarted(reservationId: any): PaymentAction {
  return {
    type: PAYMENT_STARTED,
    reservationId,
  };
}

export function setPaymentInReview(reservationId: any): PaymentAction {
  return {
    type: PAYMENT_IN_REVIEW,
    reservationId,
  };
}

export function setPaymentCreated(reservationId: any): PaymentAction {
  return {
    type: PAYMENT_CREATED,
    reservationId,
  };
}

export function setDefaultPaymentSourceUpdated(paymentSourceId: any): PaymentAction {
  return {
    type: PAYMENT_SOURCE_UPDATED,
    paymentSourceId,
  };
}

export const createPayment = (data: any, reservationId: any) => ({
  type: PAYMENT_CREATED,
  payload: {
    client: "default",
    request: {
      url: `/v1/my/reservation/${reservationId}/payment`,
      method: "post",
      data,
    },
  },
});

export const createRecoveryPayment = (data: any, reservationId: any) => ({
  type: PAYMENT_CREATED,
  payload: {
    client: "default",
    request: {
      url: `/v1/my/reservation/${reservationId}/recovery_payment`,
      method: "post",
      data,
    },
  },
});
